const INNOVA_COLOMBIA_NETWORK = 'innova-colombia'
const TEMPLATE_NAMES_WITH_GENDER_OVERRIDE = ['Plantilla_ES_V2', 'Plantilla_ES_v2']
const GENDER_QUESTION_TEXT_OVERRIDE = 'Soy ...'
const GENDER_OPTIONS_OVERRIDE = {
  femenino: 'Una niña/mujer',
  masculino: 'Un niño/hombre',
  otro: 'Otro',
  ninguno: 'Prefiero no decirlo'
}

const normalizeText = value => {
  if (!value) return ''

  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase()
}

const isInnovaColombiaNetwork = network =>
  normalizeText(network) === INNOVA_COLOMBIA_NETWORK

const hasTemplateWithGenderOverride = templateName =>
  TEMPLATE_NAMES_WITH_GENDER_OVERRIDE.includes(templateName)

const hasV2GenderOptionsSignature = question => {
  const normalizedOptionNames = (question?.question_textId?.answers || [])
    .map(answer => normalizeText(answer?.name))

  return [
    'femenino',
    'masculino',
    'otro',
    'ninguno'
  ].every(optionName => normalizedOptionNames.includes(optionName))
}

const isCharacterizationGenderQuestion = ({ question, index, pageName }) => {
  const normalizedPageName = normalizeText(pageName)
  const normalizedQuestionText = normalizeText(question?.question_textId?.name)
  const isCharacterizationPage = normalizedPageName.includes('caracterizacion')
  const isGenderQuestion = normalizedQuestionText.includes('genero')
  const isFirstQuestion = index === 0 || Number(question?.position) === 1

  return (
    question?.question_textId?.type === 'radio' &&
    isCharacterizationPage &&
    isGenderQuestion &&
    isFirstQuestion
  )
}

export const getQuestionWithInnovaGenderOverride = ({
  question,
  index,
  pageName,
  network,
  templateName
}) => {
  const isV2TemplateByName = hasTemplateWithGenderOverride(templateName)
  const isV2TemplateByFallback = !templateName && hasV2GenderOptionsSignature(question)

  const shouldOverrideQuestion =
    isInnovaColombiaNetwork(network) &&
    (isV2TemplateByName || isV2TemplateByFallback) &&
    isCharacterizationGenderQuestion({ question, index, pageName })

  if (!shouldOverrideQuestion) return question

  return {
    ...question,
    question_textId: {
      ...question.question_textId,
      name: GENDER_QUESTION_TEXT_OVERRIDE,
      answers: question.question_textId.answers.map(answer => {
        const normalizedAnswerName = normalizeText(answer?.name)

        return {
          ...answer,
          name: GENDER_OPTIONS_OVERRIDE[normalizedAnswerName] || answer?.name
        }
      })
    }
  }
}
